var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "image-uploader" },
    [
      _c(
        "div",
        {
          staticClass: "upload-click-wrap",
          class: { "has-image": !!_vm.finalPreview },
          attrs: { role: "button" },
          on: { click: _vm.triggerUpload },
        },
        [
          _vm.finalPreview
            ? _c("img", {
                staticClass: "upload-img",
                attrs: { src: _vm.finalPreview, alt: _vm.altText },
              })
            : _c("div", { staticClass: "upload-placeholder" }, [
                _c("i", { staticClass: "el-icon-plus" }),
                _c("span", [_vm._v(_vm._s(_vm.placeholder))]),
              ]),
          _vm.finalPreview
            ? _c(
                "button",
                {
                  staticClass: "preview-btn",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.openPreview.apply(null, arguments)
                    },
                  },
                },
                [_c("i", { staticClass: "el-icon-view" })]
              )
            : _vm._e(),
          _c("el-upload", {
            ref: "uploader",
            staticClass: "hidden-upload",
            attrs: {
              disabled: !_vm.updateAttendance,
              "show-file-list": false,
              "on-change": _vm.handleChange,
              "auto-upload": false,
              limit: 1,
              accept: "image/jpeg,image/png",
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "image-preview-dialog",
          attrs: {
            visible: _vm.previewDialogVisible,
            width: "900px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "preview-scroll-container" }, [
            _c("img", {
              staticClass: "full-preview-image",
              attrs: { src: _vm.finalPreview },
            }),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }